<template>
	<div ref="parent"
		class="parent">
		<DotWrapper :key="renderKey"
					:count="backgroundEngine.particles.count"
					:size="backgroundEngine.particles.startRadius"
					:grid="backgroundEngine.particles.grid" />
		<div class="animators">
			<div id="leftAnimator">
<!-- 				<Arbor class="arbor"
						:systemParms="system"
						:particleParms="particles"/>
 -->				<img src="../../assets/img/tempDev.png">
			</div>
			<div id="rightAnimator">
				<img src="../../assets/img/avatars/0avatar.png">
			</div>
		</div>
	</div>
</template>

<script>
	import DotWrapper from './DotWrapper';
	// import Arbor from 'ArborVue';

	export default {
		name: "Background",
		components : { DotWrapper },
		created(){
			this.$root.$on('bioEnter', () => { this.backgroundEngine.animateEnter(); });

			this.$root.$on('skillEnter', () => { this.backgroundEngine.animateEnter(); });

			this.$root.$on('skillExit', () => { this.backgroundEngine.animateSkillExit(); });

			this.$root.$on('exit', () => { this.backgroundEngine.restartAnimation(); });
		},
		data(){
			let color = {
				black: 		'#000000',	//Home
				background: '#7db4b5',  //Background
				eyeview: 	'#069653',	//Eyeview
				ibm: 		'#1871c3',	//IBM
				tiaa: 		'#8facca',	//Tiaa
				verizon: 	'#cd0504',	//verizon
			};

			return {
				renderKey : 0,
				avatar : this.backgroundEngine.bio.paths,
				system : {
					stiffness:700,
					repulsion:700,
					gravity:false,
					dt:0.015
				},
				particles : {
					nodes:{
						central:{
							'color': color.black,
							'shape': 'dot',
							'radius': 10,
							'alpha': 1
						},
						eyeview : {
							'color': color.background,
							'shape': 'dot',
							'radius': 75,
							'image': 'eyeview.png',
							'image_w': 30,
							'image_h': 30,
							'alpha': 1
						},
						ev1:{
							'color': color.eyeview,
							'label':'AngularJS',
							'alpha': 0
						},
						ev2:{
							'color': color.eyeview,
							'label':'VueJS',
							'alpha': 0
						},
						ev3:{
							'color': color.eyeview,
							'label':'Java',
							'alpha': 0
						},
						ev4:{
							'color': color.eyeview,
							'label': 'AWS',
							'alpha': 0
						},
						ev5:{
							'color': color.eyeview,
							'label': 'Docker',
							'alpha': 0
						},
						ev6:{
							'color': color.eyeview,
							'label': 'MongoDB',
							'alpha': 0
						},
						ev7:{
							'color': color.eyeview,
							'label': 'DropWizard',
							'alpha': 0
						},
						ev8:{
							'color': color.eyeview,
							'label': 'Python',
							'alpha': 0
						},
						ev9:{
							'color': color.eyeview,
							'label': 'Git',
							'alpha': 0
						},
						ev10:{
							'color': color.eyeview,
							'label': 'RabbitMQ',
							'alpha': 0
						},

						ibm : {
							'color': color.background,
							'shape': 'dot',
							'radius': 75,
							'image': 'ibm.png',
							'image_w': 30,
							'image_h': 15,
							'alpha': 1
						},
						ibm1:{
							'color': color.ibm,
							'label': 'Java',
							'alpha': 0
						},
						ibm2:{
							'color': color.ibm,
							'label': 'z/OS',
							'alpha': 0
						},
						ibm3:{
							'color': color.ibm,
							'label': 'Watson Image Api',
							'alpha': 0
						},

						tiaa : {
							'color': color.background,
							'shape': 'dot',
							'radius': 75,
							'image': 'tiaa.png',
							'image_w': 30,
							'image_h': 30,
							'alpha': 1
						},
						tiaa1:{
							'color': color.tiaa,
							'label': 'Git',
							'alpha': 0
						},
						tiaa2:{
							'color': color.tiaa,
							'label': 'Maven',
							'alpha': 0
						},
						tiaa3:{
							'color': color.tiaa,
							'label': 'Hadoop',
							'alpha': 0
						},
						tiaa4:{
							'color': color.tiaa,
							'label': 'Java',
							'alpha': 0
						},

						verizon : {
							'color': color.background,
							'shape': 'dot',
							'radius': 75,
							'image': 'verizon-wireless.png',
							'image_w': 30,
							'image_h': 30,
							'alpha': 1
						},
						verizon1:{
							'color': color.verizon,
							'label': 'PHP',
							'alpha': 0
						},
						verizon2:{
							'color': color.verizon,
							'label': 'Flask',
							'alpha': 0
						},
						verizon3:{
							'color': color.verizon,
							'label': 'Powershell',
							'alpha': 0
						},
						verizon4:{
							'color': color.verizon,
							'label': 'Oracle SQL',
							'alpha': 0
						}
					},
					edges:{
						central:{
							eyeview:{},
							ibm:{},
							tiaa:{},
							verizon:{}
						},
						eyeview:{
							ev1:{},
							ev2:{},
							ev3:{},
							ev4:{},
							ev5:{},
							ev6:{},
							ev7:{},
							ev8:{},
							ev9:{},
							ev10:{}
						},
						ibm:{
							ibm1:{},
							ibm2:{},
							ibm3:{}
						},
						tiaa:{
							tiaa1:{},
							tiaa2:{},
							tiaa3:{},
							tiaa4:{}
						},
						verizon:{
							verizon1:{},
							verizon2:{},
							verizon3:{},
							verizon4:{}
						}
					}
				}
			}
		},
        dependencies : ['backgroundEngine'],
        mounted(){
            window.addEventListener('resize', this.onResize);
            this.backgroundEngine.configureCanvas();
            this.backgroundEngine.animate();
        },
        beforeDestroy() {   //    Code to run when DOM unloads
            window.removeEventListener('resize', this.onResize);
        },
        methods : {
            onResize : function(event){
                event.preventDefault();
                this.backgroundEngine.resizeTriggered(event, this.$refs);
                this.updateRenderKey();
                this.backgroundEngine.restartAnimation();
            },
            updateRenderKey: function(){
                this.renderKey = (this.renderKey > 0) ? 0 : 1;
            },
            reset : function(){
                this.updateRenderKey();
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';
    .parent{
        position: fixed;
        box-sizing: border-box;
        height: 100vh;
        width: 100vw;
        z-index:-10;

        #backgroundCanvas{
            position: absolute;
            transform-origin: left top;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
        }

        .dot{
            z-index: 1;
            margin: 1em;
            background-color: #000;
            border-radius: 50%;

            .breakline{
                &::before{
                    content: "\A";
                    white-space: pre;
                }
            }
        }

        .animators{
            width: 100vw;
            height: 100vh;
            opacity: 0;
            display: inline-flex;

            > *{
                position: relative;
                z-index: 7;
                height: 100%;
            }
            #leftAnimator{
                width: 50%;
                background: white;
                text-align:center;
                > img{
                    position: relative;
                    width:40%;
                    margin-left: auto;
                    margin-right: auto;
                    top:35%;
                }                
            }

            #rightAnimator{
                background: black;
                > img{
                    height: 75%;
                    bottom: 0;
                    position: absolute;
                }
            }
        }

        @media screen and (max-width:$tabletWidth){
            .animators{
                display: none;
            }
        }        
    }
</style>
